import LazyImage from "./ui/LazyImage";
import { useEffect, useRef } from "react";

type Props = {
  src: string;
  alt: string;
  className?: string;
  active?: boolean;
  preview?: boolean;
  onClick?: () => void;
};

export const isVideoUrl = (url: string) =>
  /\.(mp4|webm|mov|m4v|ogv|ogg|m3u8|mpd)(?:[?#]|$)/i.test(url);

export default function GalleryMedia({
  src,
  alt,
  className,
  active = true,
  preview = false,
  onClick,
}: Props) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!active) videoRef.current?.pause();
  }, [active]);

  if (!isVideoUrl(src)) {
    return (
      <LazyImage
        src={src}
        alt={alt}
        className={className}
        draggable={false}
        onClick={onClick}
      />
    );
  }

  if (preview) {
    return (
      <button
        type="button"
        aria-label="پخش ویدیو"
        onClick={onClick}
        className={`relative block ${className}`}
      >
        <video
          src={src}
          muted
          playsInline
          preload="metadata"
          className="w-full h-full object-cover"
        />
        <span
          aria-hidden="true"
          className="absolute inset-0 flex items-center justify-center bg-black/20 text-white text-2xl"
        >
          ▶
        </span>
      </button>
    );
  }

  return (
    <video
      ref={videoRef}
      src={src}
      aria-label={alt || "ویدیو"}
      controls
      playsInline
      preload="metadata"
      className={`bg-black ${className ?? ""}`}
      style={{ objectFit: "contain" }}
      onClick={(event) => event.stopPropagation()}
      onPointerDown={(event) => event.stopPropagation()}
    />
  );
}
